
export const AwardsSectionView = ({ awards = [] }) => {
  return (
    <div className="flex flex-col h-full">
      <h3 className="text-jp-ink font-bold text-lg mb-4">AWARDS & HONORS</h3>
      <div className="flex flex-wrap gap-3 border border-jp-line rounded-2xl p-2 min-h-[48px]">
        {awards && awards.length > 0 ? (
          awards.map((award, index) => {
            const isStringAward = typeof award === 'string';
            const awardTitle = isStringAward ? award : (award.title || award.award || 'Untitled Award');
            return (
              <span key={index} className="px-4 py-2 rounded-full bg-cyan-500/20 border border-cyan-500/40 text-jp-accent-ink text-sm font-medium">
                {awardTitle}
              </span>
            );
          })
        ) : (
          <p className="text-jp-muted text-sm px-2 py-1">No awards available</p>
        )}
      </div>
    </div>
  );
};

export default AwardsSectionView;
